"use strict";

var _interopRequireDefault = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clientsContactSubMenu = void 0;
var _interopRequireWildcard2 = _interopRequireDefault(require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/@babel/runtime/helpers/interopRequireWildcard.js"));
const clientsContactSubMenu = exports.clientsContactSubMenu = [{
  path: '/clients-contacts/list',
  component: () => Promise.resolve().then(() => (0, _interopRequireWildcard2.default)(require('@/views/clients-contacts/list.vue'))),
  name: 'leadManagement.clientsContact.title',
  meta: {
    title: 'leadManagement.clientsContact.title',
    noCache: true,
    icon: 'user',
    roles: ['Super Admin', 'Admin', 'Sales Manager', 'Sales Coordinator', 'System Admin']
  }
}, {
  path: '/clients-contacts/edit/:id(\\d+)',
  component: () => Promise.resolve().then(() => (0, _interopRequireWildcard2.default)(require('@/views/clients-contacts/manage.vue'))),
  name: 'leadManagement.clientsContact.manage',
  props: {
    isEdit: true
  },
  meta: {
    title: 'leadManagement.clientsContact.manage',
    noCache: true,
    activeMenu: '/clients-contacts/list',
    hidden: true
  }
}, {
  path: '/clients-contacts/add/',
  component: () => Promise.resolve().then(() => (0, _interopRequireWildcard2.default)(require('@/views/clients-contacts/manage.vue'))),
  name: 'leadManagement.clientsContact.manage',
  props: {
    isEdit: false
  },
  meta: {
    title: 'leadManagement.clientsContact.manage',
    noCache: true,
    activeMenu: '/clients/list',
    hidden: true
  }
}, {
  path: '/clients-contacts/import',
  component: () => Promise.resolve().then(() => (0, _interopRequireWildcard2.default)(require('@/views/clients-contacts/import.vue'))),
  name: 'leadManagement.clientsContact.import',
  props: {
    isEdit: false
  },
  meta: {
    title: 'leadManagement.clientsContact.import',
    noCache: true,
    hidden: true
  }
}];